import validate from "/var/www/share/mysofabed.de/app/node_modules/.pnpm/nuxt@3.17.5_@biomejs+biome@1.8.3_@parcel+watcher@2.5.1_@types+node@22.15.23_db0@0.3.2_e_da87fc9f9e0427cb820d26493b88beaa/node_modules/nuxt/dist/pages/runtime/validate.js";
import block_45undefined_45global from "/var/www/share/mysofabed.de/app/middleware/block-undefined.global.ts";
import loading_45global from "/var/www/share/mysofabed.de/app/middleware/loading.global.ts";
import trailing_45slash_45global from "/var/www/share/mysofabed.de/app/middleware/trailingSlash.global.ts";
import manifest_45route_45rule from "/var/www/share/mysofabed.de/app/node_modules/.pnpm/nuxt@3.17.5_@biomejs+biome@1.8.3_@parcel+watcher@2.5.1_@types+node@22.15.23_db0@0.3.2_e_da87fc9f9e0427cb820d26493b88beaa/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  block_45undefined_45global,
  loading_45global,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}